<nav class="iguau-accesos" aria-label="Descubre iGuau">
  <a *ngFor="let acceso of accesos; trackBy: trackByTitulo"
     class="iguau-acceso"
     [href]="acceso.url"
     [attr.aria-label]="acceso.etiqueta">
    <span class="iguau-acceso-icono" aria-hidden="true">
      <i [class]="'fa-solid ' + acceso.icono"></i>
    </span>
    <span class="iguau-acceso-texto">
      <span>{{ acceso.titulo }}</span>
      <span>{{ acceso.subtitulo }}</span>
    </span>
  </a>
</nav>
